import React from "react";

const Pagination = ({
  currentPage,
  totalPages,
  onNextPage,
  onPrevPage,
  onPageClick,
}) => {
  if (!totalPages || totalPages <= 1) return null;

  const createPageNumbers = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    // Always show first, last, current, and neighbours
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    pages.push(1);
    if (start > 2) pages.push("left-ellipsis");

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 1) pages.push("right-ellipsis");
    pages.push(totalPages);

    return pages;
  };

  const pages = createPageNumbers();

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 text-xs">
      <div className="text-gray-500">
        Page <span className="font-semibold">{currentPage}</span> of{" "}
        <span className="font-semibold">{totalPages}</span>
      </div>

      <div className="flex items-center gap-1">
        {/* Prev */}
        <button
          onClick={onPrevPage}
          disabled={currentPage === 1}
          className="h-8 rounded-xl border px-2.5 text-[11px] font-medium disabled:cursor-not-allowed disabled:opacity-40 hover:bg-gray-50"
        >
          Prev
        </button>

        {/* Page numbers */}
        {pages.map((page, idx) => {
          if (page === "left-ellipsis" || page === "right-ellipsis") {
            return (
              <span
                key={`${page}-${idx}`}
                className="px-1 text-[11px] text-gray-400"
              >
                ...
              </span>
            );
          }

          const isActive = page === currentPage;

          return (
            <button
              key={page}
              onClick={() => onPageClick(page)}
              className={`h-8 min-w-[32px] rounded-xl border px-2 text-[11px] font-medium ${
                isActive
                  ? "border-[#01C37D] bg-[#01C37D]/10 text-[#01C37D]"
                  : "border-gray-200 text-gray-600 hover:bg-gray-50"
              }`}
            >
              {page}
            </button>
          );
        })}

        {/* Next */}
        <button
          onClick={onNextPage}
          disabled={currentPage === totalPages}
          className="h-8 rounded-xl border px-2.5 text-[11px] font-medium disabled:cursor-not-allowed disabled:opacity-40 hover:bg-gray-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
